(function ($) {
    'use strict';

    $(function() {
        var $form = $('form.form--letter');
        $form.on('ajaxBeforeSend', function () {
            $form.append($('<div>', {
                class: 'loader-wrap',
                append: $('<div>', {
                    class: 'loader',
                    append: function () {
                        var elementsArray = [];
                        for (var i = 0; i < 8; i++) {
                            elementsArray.push($('<div>', {class: 'circle'}));
                        }
                        return elementsArray;
                    }
                })
            }));
        });

        $form.on('ajaxComplete', function () {
            $form.find('.loader-wrap').remove();
        });

        $('.js-trainer-questions').each(function () {
            $(this).trainerQuestions();
        });
    });
})(jQuery);
